import { LosseLink } from '@ubo/losse-sjedel'
import { Fragment, useEffect, useState } from 'react'
import Animated from '~/components/elements/Animated'
import GreenGreenGrass from '~/components/elements/GreenGreenGrass'
import type { Page_Flexcontent_Flex_Hubspot } from '~/graphql/types'

export default function HubspotBannerArticle({ fields }: { fields: Page_Flexcontent_Flex_Hubspot }) {
  const [profileUrl, setProfileUrl] = useState<string | null>('/profiel/')

  useEffect(() => {
    setProfileUrl(localStorage.getItem('profield_profile_url'))
  }, [])

  return (
    <section
      data-component="HubspotBannerArticle"
      className="bg-site-base pb-10 lg:pb-[130px] pt-[100px] lg:pt-[150px] -mt-[100px] relative"
    >
      <Animated delay={0}>
        <div className="absolute top-0 right-0 w-[642px]">
          <GreenGreenGrass className="w-full max-sm:opacity-30" />
        </div>
      </Animated>
      <div className="container">
        <div className="">
          {profileUrl && (
            <Animated delay={0}>
              <div>
                <LosseLink to={profileUrl} className="text-white hover:underline">
                  &lt; Terug naar je Pro Portal Overzicht
                </LosseLink>
              </div>
            </Animated>
          )}

          <Animated delay={100}>
            <h1 className="title--medium !leading-[1.2] text-white mt-24 sm:mt-36">
              {fields.title?.split('|')?.map((t, i) => (
                <Fragment key={i}>
                  <span key={i}>{t}</span>
                  <br className="last:hidden" />
                </Fragment>
              ))}
            </h1>
          </Animated>
          {fields.links && (
            <Animated delay={200}>
              <div className="flex items-center gap-3 mt-12">
                {fields.links?.map((link, i) => (
                  <LosseLink className="btn--conversion" key={i} target={link.link.target || '_self'} to={link.link.url}>
                    {link.link.title}
                  </LosseLink>
                ))}
              </div>
            </Animated>
          )}
        </div>
      </div>
    </section>
  )
}
